import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "content-files-list__item",
  "data-testing": "sb-content-files-list"
}
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "name-text" }
const _hoisted_4 = { class: "size" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "date" }
const _hoisted_7 = { class: "open" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "actions" }
const _hoisted_10 = {
  class: "btn-3",
  "data-testing": "sb-open-file-bar"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]

import {
  mdiArrowRight,
  mdiContentCopy,
  mdiDelete,
  mdiDotsHorizontal,
  mdiDownload,
  mdiOpenInNew,
  mdiPencil,
  mdiPresentationPlay,
  mdiUpload
} from "@mdi/js";
import { computed, PropType } from "vue";

import { copyToClipboard } from "@/services/copy-to-clipboard";
import { useFilesStore } from "@/stores/files.store";

import { LibraryFile } from "@/models/files.model";
import { SectionFile } from "@/models/product-section.model";

import { isAValidPathToTheLocalFile, isSafeUrl } from "@/utils/file-helpers";

import FileListItemIcon from "@/components/right-sidebars/content-sidebar/authoring-tool/FileListItemIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FilesListItem',
  props: {
  file: {
    type: Object as PropType<SectionFile | LibraryFile>,
    required: true
  },
  isAttachmentTable: {
    type: Boolean,
    required: true,
    default: true
  }
},
  emits: [
  "showFileInLibrary",
  "launchRemoveAttachmentDialog",
  "openUploadVersionModal",
  "launchRenamePopup",
  "previewAttachment"
],
  setup(__props) {

const filesStore = useFilesStore();



const props = __props;

const isAttachedFile = computed<boolean>(() => {
  // This check is needed due to a change in the logic of setting a file as media content
  // Before we could set a file as media content without attaching it to a section
  // The file exists in the file library. Check if the file is attached to the section
  return !!(props.file as SectionFile).file_to_section_id;
});
const isFileAvailable = computed<boolean>(() => {
  // This check is needed due to a change in the logic of setting a file as media content
  // Before we could set a file as media content without uploading it in the file library
  // Check if the file exists in the file library
  return !!props.file.id;
});
const isFileLocationLocal = computed<boolean>(() => {
  return !!props.file && isAValidPathToTheLocalFile(props.file.location);
});
const isFileLocationRemote = computed<boolean>(() => {
  return (
    !!props.file.is_external &&
    !isFileLocationLocal.value &&
    isSafeUrl(props.file.location)
  );
});

const dateAdded = computed<string>(() => {
  const options = {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
    timezone: "UTC",
    hour: "2-digit",
    minute: "2-digit"
  };
  // There can be three options:
  // 1. a file is in the library and attached to the section.
  // This file has type RenameThothFile. So, we use property 'file_created_on'
  // 2. a file is not added to the section, but is in the library.
  // This file has type ThothFile. So, we use property 'created_on'
  // 3. a file is not in the library, but it is added as media content
  const fileCreatedOn = (props.file as SectionFile).file_created_on
    ? (props.file as SectionFile).file_created_on
    : (props.file as LibraryFile).created_on
    ? (props.file as LibraryFile).created_on
    : undefined;
  return fileCreatedOn
    ? // @ts-expect-error fileCreatedOn may be a non-standard date format
      new Date(fileCreatedOn).toLocaleString("en", options)
    : "";
});
const fileSize = computed<number>(() => {
  if (filesStore.files) {
    const currentFile = filesStore.files.find((f: LibraryFile): boolean => {
      return f.id === props.file.id;
    });
    if (currentFile) {
      return currentFile.versions[currentFile.versions.length - 1].file_size;
    }
  }
  return 0;
});

return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!

  return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _createElementVNode("td", _hoisted_2, [
      _createVNode(FileListItemIcon, {
        "file-location": __props.file.location
      }, null, 8, ["file-location"]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.file.name), 1)
    ]),
    _createElementVNode("td", _hoisted_4, [
      (fileSize.value > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(fileSize.value + "kb"), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", _hoisted_6, _toDisplayString(dateAdded.value), 1),
    _cache[14] || (_cache[14] = _createElementVNode("td", { class: "info" }, null, -1)),
    _createElementVNode("td", _hoisted_7, [
      (isFileLocationRemote.value)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: __props.file.location,
            target: "_blank",
            title: "Open attachment in a new tab"
          }, [
            _createVNode(_component_SVGIcon, { path: _unref(mdiOpenInNew) }, null, 8, ["path"])
          ], 8, _hoisted_8))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", _hoisted_9, [
      _createVNode(_component_b_dropdown, {
        position: "is-bottom-left",
        class: "file-btn"
      }, {
        trigger: _withCtx(() => [
          _createElementVNode("button", _hoisted_10, [
            _createVNode(_component_SVGIcon, {
              path: _unref(mdiDotsHorizontal),
              size: 18
            }, null, 8, ["path"])
          ])
        ]),
        default: _withCtx(() => [
          (__props.isAttachmentTable)
            ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                key: 0,
                "aria-role": "listitem",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('previewAttachment', __props.file.location)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SVGIcon, { path: _unref(mdiPresentationPlay) }, null, 8, ["path"]),
                  _cache[6] || (_cache[6] = _createTextVNode(" Preview ", -1))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (isFileLocationRemote.value)
            ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                key: 1,
                "aria-role": "listitem"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: __props.file.location,
                    target: "_blank"
                  }, [
                    _createVNode(_component_SVGIcon, { path: _unref(mdiOpenInNew) }, null, 8, ["path"]),
                    _cache[7] || (_cache[7] = _createTextVNode(" Open attachment ", -1))
                  ], 8, _hoisted_11)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (isFileLocationLocal.value)
            ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                key: 2,
                "aria-role": "listitem",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(copyToClipboard)(__props.file.location)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SVGIcon, { path: _unref(mdiContentCopy) }, null, 8, ["path"]),
                  _cache[8] || (_cache[8] = _createTextVNode(" Copy path ", -1))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (isFileAvailable.value)
            ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                key: 3,
                "aria-role": "listitem",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('launchRenamePopup', __props.file)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SVGIcon, { path: _unref(mdiPencil) }, null, 8, ["path"]),
                  _cache[9] || (_cache[9] = _createTextVNode(" Rename ", -1))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!__props.file.is_external && _unref(isSafeUrl)(__props.file.location))
            ? (_openBlock(), _createBlock(_component_b_dropdown_item, { key: 4 }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: __props.file.location,
                    download: "",
                    title: "Download this attachment to your computer",
                    class: "nstyled btn-3 full-width"
                  }, [
                    _createVNode(_component_SVGIcon, { path: _unref(mdiDownload) }, null, 8, ["path"]),
                    _cache[10] || (_cache[10] = _createTextVNode(" Download ", -1))
                  ], 8, _hoisted_12)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (isFileAvailable.value && !__props.file.is_external)
            ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                key: 5,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('openUploadVersionModal', __props.file)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SVGIcon, { path: _unref(mdiUpload) }, null, 8, ["path"]),
                  _cache[11] || (_cache[11] = _createTextVNode(" Upload a new version ", -1))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (isFileAvailable.value)
            ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                key: 6,
                "aria-role": "listitem",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('showFileInLibrary', __props.file)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SVGIcon, { path: _unref(mdiArrowRight) }, null, 8, ["path"]),
                  _cache[12] || (_cache[12] = _createTextVNode(" Open in file library ", -1))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (isFileAvailable.value && isAttachedFile.value)
            ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                key: 7,
                "aria-role": "listitem",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('launchRemoveAttachmentDialog', __props.file))),
                "data-testing": "sb-remove-attachment"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SVGIcon, { path: _unref(mdiDelete) }, null, 8, ["path"]),
                  _cache[13] || (_cache[13] = _createTextVNode(" Remove attachment ", -1))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})